import React from "react";
import "./dialog-text-list-item.css";
import "./dialog-text-list-item-animation.css";

export class DialogTextListItem extends React.Component {
  render() {
    return (
      <div className="dialog-text-list-item">
        <span className="dialog-text-list-item__headline">
          {this.props.person}:
        </span>
        <br />
        <span className="dialog-text-list-item__content">
          {this.props.text}
        </span>
      </div>
    );
  }
}
